import api from "@/lib/api";

/**
 * Business-Only Refactor pricing model:
 * - Boutique: $9.99/card, pay-per-mail (no subscription).
 * - Credit Packs (10/25/50 cards): one-time purchase; ALSO permanently unlocks premium
 *   sentiment features (Magic Wand, Wishlist, Legacy Vault, Cash Gifting, Circles, Royal Voice,
 *   Bespoke Mashup, Arrangements).
 * - Business Team Plan ($29/mo): B2B — Bulk CSV + AI Address Auditor, Scheduled Sends,
 *   Corporate Seal, Sentiment Dashboard. Org creation itself stays free.
 */

export function isPremiumUnlocked(user) {
  return !!(user && (user.premium_unlocked || user.is_root_admin));
}

export function isBusinessActive(user) {
  return !!(user && (user.business_plan_active || user.is_root_admin));
}

/** Buy a Credit Pack ("pack10" | "pack25" | "pack50") — redirects to live Stripe Checkout. */
export async function startCreditPackCheckout(pack) {
  const res = await api.post("/credits/purchase", { pack });
  if (res.data.mode === "live" && res.data.checkout_url) {
    window.location.href = res.data.checkout_url;
    return { redirected: true };
  }
  return { redirected: false, data: res.data };
}

/** Boutique $9.99 single-card checkout. */
export async function startSingleCardCheckout(cardId) {
  const res = await api.post("/payments/single-card-checkout", { card_id: cardId || "" });
  if (res.data.mode === "live" && res.data.checkout_url) {
    window.location.href = res.data.checkout_url;
    return { redirected: true };
  }
  return { redirected: false, data: res.data };
}

/** $29/mo Business Team Plan checkout. */
export async function startBusinessCheckout() {
  const res = await api.post("/business/subscribe");
  if (res.data.mode === "live" && res.data.checkout_url) {
    window.location.href = res.data.checkout_url;
    return { redirected: true };
  }
  return { redirected: false, data: res.data };
}
